/**
 * Imperative save bridge so App/EditorView can flush + persist
 * before leaving the editor (Back/Close).
 */

type EditorSaveHandler = () => Promise<boolean>;

let handler: EditorSaveHandler | null = null;

export function registerEditorSaveHandler(next: EditorSaveHandler | null): void {
  handler = next;
}

/** Flush live canvas into the project and save to Firestore. */
export async function requestEditorSave(): Promise<boolean> {
  if (!handler) return true;
  return handler();
}
